export default {
  meta: {
    title: $localize`:@@meta.landing.title:CSFAIL — Эпические битвы за скины: Побеждай скинами Counter-Strike 2, Dota 2 и Rust`,
    description: $localize`:@@meta.landing.description:Присоединяйся к лучшей битве для скинов CS2, Dota 2 и Rust! Проверь свою удачу и стратегию в захватывающих битвах за скины и эксклюзивном ивенте. Соревнуйся, выигрывай редкие скины и докажи, что ты чемпион арены!`
  }
};